import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DwConfigService, DwConfigServiceToken } from '@devwareapps/devware-cap';
import { defer, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CommentCommand, Discussion } from '../models/activity-discussion.models';
import { CentralDataService } from './central-data.service';
import { ActivityFeedService } from './activity-feed.service';
import { BadgeService } from '../../gamification/services/badge.service';
@Injectable({ providedIn: 'root' })
export class ActivityDiscussionService {
    constructor(private http: HttpClient, @Inject(DwConfigServiceToken) private config: DwConfigService,
        private data: CentralDataService, private feed: ActivityFeedService, private badges: BadgeService) {}
    private url(id: number): string { return this.config.coreConfig.apiRoot.replace(/\/$/, '') + '/fitness/activities/' + id + '/discussion'; }
    read(id: number, force = false): Observable<Discussion> {
        return defer(() => {
            if (force) { this.data.expireSnapshot('activity-discussion:' + id); }
            return this.data.snapshot('activity-discussion:' + id, () => this.http.get<Discussion>(this.url(id)), 120000);
        });
    }
    like(id: number, liked: boolean): Observable<{ Likes: number; Liked: boolean; CommentCount: number }> {
        return defer(() => {
            const scope = this.data.cacheScope();
            return this.http.put<{ Likes: number; Liked: boolean; CommentCount: number }>(this.url(id) + '/like', { Liked: liked }).pipe(take(1), map(result => {
                if (scope !== this.data.cacheScope()) { throw new Error('Account changed while saving.'); }
                this.feed.updateReactions(id, result.Likes, result.Liked, result.CommentCount);
                this.badges?.refreshAwards();
                const cached = this.data.cacheValue<Discussion>('activity-discussion:' + id);
                if (cached && cached.Comments.length === result.CommentCount) {
                    this.data.storeSnapshot('activity-discussion:' + id, { ...cached, Likes: result.Likes, Liked: result.Liked }, 120000);
                }
                return result;
            }));
        });
    }
    post(id: number, command: CommentCommand): Observable<Discussion> {
        return defer(() => {
            const scope = this.data.cacheScope();
            return this.http.post<Discussion>(this.url(id) + '/comments', command).pipe(take(1), map(result => {
                if (scope !== this.data.cacheScope()) { throw new Error('Account changed while saving.'); }
                this.feed.updateReactions(id, result.Likes, result.Liked, result.Comments.length);
                this.badges?.refreshAwards();
                this.data.storeSnapshot('activity-discussion:' + id, result, 120000);
                return result;
            }));
        });
    }
}
